module.exports = function ($stateProvider, $urlRouterProvider) {
    // Redirect "Your Specials" to "My Specials
    $urlRouterProvider.when('/SpecialsGroups/your-specials', '/SpecialsGroups/my-specials');

    $stateProvider
        .state('shop.specials', {
            // url: '/specials',
            abstract: true,
            data: {
                isScrollerOpen: false
            }
        })
        .state('shop.specials.groupsv2', {
            url: '/specials-groups',
            controller: [
                '$scope', '$state', function ($scope, $state) {
                    if (!($scope.breakpointsService.isSmallFormat() && $scope.SmallFormatCentrePanelSlideEnabled)) {
                        $state.go('shop.specials.groups');
                    }
                }
            ],
            data: {
                analytics: `bws:web:specials-groups`,
                pageMetadata: {
                    metaRobot: 'noindex, nofollow'
                },
                isScrollerOpen: false
            }
        })
        .state('shop.specials.groups', {
            url: '^/specials-groups/{specialGroup}?{name}&{productId:int}&{recipeId:int}&{cardId:int}&{pageNumber:int}',
            resolve: {
                specialsGroups: [
                    'SpecialsGroupsService', function (specialsGroupsService) {
                        return specialsGroupsService.listGroups();
                    }
                ]
            },
            views: {
                'center-panel@': {
                    controller: [
                        'InlineCoachingService', '$scope', function (inlineCoachingService, $scope) {
                            $scope.inlineCoaching = inlineCoachingService;
                        }
                    ],
                    template: require('../../components/specials/specials-group-center-panel-template.html').trim()
                },
                'sticky-header@': {
                    controller: [
                        'SpecialsGroupsService', 'BreakpointsService', 'SettingsService', 'hyphenateFilter', '$scope', '$state', function (specialsGroupsService, breakpointsService, settingsService, hyphenate, $scope, $state) {
                            $scope.breakpointsService = breakpointsService;
                            settingsService.getSettingValue('OneSite', 'SmallFormatCentrePanelSlideEnabled').then(function (setting) {
                                $scope.smallFormatCentrePanelSlideEnabled = setting;
                            });
                            const _ = require('lodash');

                            if ($state.params.specialGroup) {
                                const groupName = $state.params.specialGroup;

                                specialsGroupsService.listGroups().then(function (groups) {
                                    const selectedSpGroup = _.find(groups, function (group) { return hyphenate(group.Name) === groupName; });
                                    specialsGroupsService.selectGroup(selectedSpGroup);
                                    $scope.title = specialsGroupsService.selectedGroup.Name;
                                });
                            }
                            $scope.redirectTo = 'shop.specials.groupsv2';
                        }
                    ],
                    template: '<oly-sticky-header-with-text ng-if="breakpointsService.isSmallFormat() && smallFormatCentrePanelSlideEnabled"></oly-sticky-header-with-text>'
                }
            },
            data: {
                isScrollerOpen: false,
                showBothPanelsInSmallFormat: true,
                pageMetadata: [
                    'SpecialsGroupsService', 'PageMetadataService', 'hyphenateFilter', '$stateParams', function (specialsGroupsService, pageMetadataService, hyphenate, $stateParams) {
                        if ($stateParams.specialGroup) {
                            const _ = require('lodash');
                            return specialsGroupsService.listGroups().then(function (groups) {
                                const selectedSpGroup = _.find(groups, function (group) { return hyphenate(group.Name) === $stateParams.specialGroup; });
                                specialsGroupsService.selectGroup(selectedSpGroup);
                                if (!($stateParams.specialGroup === 'catalogue')) {
                                    return pageMetadataService.updateMetadata({ name: specialsGroupsService.selectedGroup.Name }, true, null, 'Special', true);
                                }
                                return pageMetadataService.updateMetadata({ name: specialsGroupsService.selectedGroup.Name }, true, null, 'Special', false);
                            });
                        }
                        return pageMetadataService.getMetadata(null, true, null, 'Special');
                    }
                ]
            }
        })
        .state('shop.specials.landing', {
            url: '^/specials-groups',
            onEnter: [
                'PageMetadataService', function (pageMetadataService) {
                    pageMetadataService.updateMetadata({ name: '' }, true, null, 'Special', true);
                }
            ]
        })
        .state('shop.specials.browse', {
            url: '^/browse-specials',
            resolve: {
                categories: [
                    'CategoriesService', function (categoriesService) {
                        return categoriesService.getAll(true);
                    }
                ]
            },
            views: {
                'center-panel@': {
                    controller: [
                        'InlineCoachingService', '$scope', '$state', 'hyphenateFilter', 'BreakpointsService', 'CategoriesService', function (inlineCoachingService, $scope, $state, hyphenate, breakpointsService, categoriesService) {
                            this.$onInit = function() {
                                $scope.inlineCoaching = inlineCoachingService;
                                const _ = require('lodash');
                                $scope.selectedCategory = categoriesService.currentCategory;

                                if ($state.params.category && breakpointsService.isSmallFormat()) {
                                    const categoryName = $state.params.category;

                                    $scope.selectedCategory.department = _.find(categoriesService.specials, function (category) { return hyphenate(category.Name) === categoryName; });

                                    if (!$scope.selectedCategory.department) {
                                        $state.go('shop.specials.browse');
                                    }

                                    const aisleName = $state.params.aisle;

                                    if (aisleName) {
                                        $scope.selectedCategory.aisle = _.find($scope.selectedCategory.department.ChildCategories, function (aisle) { return hyphenate(aisle.Name) === aisleName; });
                                    } else {
                                        $scope.selectedCategory.aisle = $scope.selectedCategory.department.ChildCategories[0];
                                    }

                                    if (!$scope.selectedCategory.aisle) {
                                        $state.go('shop.specials.browse');
                                    }

                                    categoriesService.setSelectedCategory($scope.selectedCategory.department, $scope.selectedCategory.aisle);
                                }
                            };
                        }
                    ],
                    template: require('../../components/specials/specials-category-center-panel-template.html').trim()
                }
            },
            data: {
                isScrollerOpen: true,
                shouldGetMetadata: false
            }
        })
        .state('shop.specials.browse.category', {
            url: '/:category'
        })
        .state('shop.specials.browse.category.aisle', {
            url: '/:aisle?{name}&{productId:int}&{recipeId:int}&{cardId:int}&{pageNumber:int}',
            views: {
                'sticky-header@': {
                    controller: [
                        'CategoriesService', 'BreakpointsService', 'SettingsService', '$scope', '$state',
                        function (categoriesService, breakpointsService, settingsService, $scope, $state) {
                            this.$onInit = function() {
                                $scope.breakpointsService = breakpointsService;

                                settingsService.getSettingValue('OneSite', 'SmallFormatCentrePanelSlideEnabled').then(function (setting) {
                                    $scope.smallFormatCentrePanelSlideEnabled = setting;
                                });

                                if (categoriesService.currentCategory.aisle && $state.params.aisle === categoriesService.currentCategory.aisle.UrlFriendlyName) {
                                    $scope.selectedCategory = categoriesService.currentCategory.aisle;
                                } else {
                                    const selectedCategory = categoriesService.getCategoryByName($state.params.category, $state.params.aisle);
                                    $scope.selectedCategory = selectedCategory.aisle;
                                }

                                $scope.title = $scope.selectedCategory.Name;
                                $scope.retinaDisplayimage = `/Content/wowCategoryImages/large/${$scope.selectedCategory.ImageFile}`;
                                $scope.image = `/Content/wowCategoryImages/small/${$scope.selectedCategory.ImageFile}`;
                                $scope.redirectTo = 'shop.specials.browse';
                            };
                        }
                    ],
                    template: '<oly-sticky-header-with-image retina-image="retinaDisplayimage" image="image" title="title" redirect-to="redirectTo" ng-if="breakpointsService.isSmallFormat() && smallFormatCentrePanelSlideEnabled"></oly-sticky-header-with-image>'
                }
            },
            data: {
                showBothPanelsInSmallFormat: true
            }
        });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/specials.js
 **/